// @flow
import React from "react";

import SelecaoRadioBaseComTraducao from "../../../comum/SelecaoRadioBaseComTraducao";
import {
  selecionarTipoConta,
  getTipoContaSelecionado,
  getTiposConta,
} from "../../../../state";

export default function SelecaoTipoConta() {
  return (
    <div className="ConfiguracaoMedida">
      <SelecaoRadioBaseComTraducao
        chaveTraducaoNomeSelecao={"tipo.de.conta"}
        itensSelector={getTiposConta}
        selectorItemSelecionado={getTipoContaSelecionado}
        onItemChange={selecionarTipoConta}
        campoId="codigo"
        campoChaveTraducao="descricao"
      />
    </div>
  );
}
